<template>
  <div class="row">
    <div class="col-12">
      <card>
        <asset-library
          :isInline="true"
          :multiple="true"
          :value="[]"
          @updateAssets="updateAssets"
        ></asset-library>
      </card>
    </div>
  </div>
</template>
<script>
import AssetLibrary from '@/components/NewAssetLibrary'

export default {

  name: "Assets",

  components: {
    AssetLibrary
  },

  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
  },

  methods: {
    updateAssets () {
      this.$store.dispatch('FETCH_ASSETS')
    }
  }
}
</script>
<style lang="scss">

</style>
